import React from 'react';

const squareWidth = 120;

export const NeutralFaceDef = () => (<g id="NeutralFace" >
  <path d="M 10 5C 10 7.76142 7.76142 10 5 10C 2.23858 10 0 7.76142 0 5C 0 2.23858 2.23858 0 5 0C 7.76142 0 10 2.23858 10 5Z" />
  <path d="M 10 5C 10 7.76142 7.76142 10 5 10C 2.23858 10 0 7.76142 0 5C 0 2.23858 2.23858 0 5 0C 7.76142 0 10 2.23858 10 5Z" transform="translate(30 0)"/>
  <path d="M 0 0L 30 0L 30 -2L 0 -2L 0 0Z" transform="translate(5 23)" />
</g>);
export const PositiveFaceDef = () => (<g id="PositiveFace"><path transform="translate(1 1)" d="M 1 5C 1 2.79086 2.79086 1 5 1L 5 -1C 1.68629 -1 -1 1.68629 -1 5L 1 5ZM 5 1C 7.20914 1 9 2.79086 9 5L 11 5C 11 1.68629 8.31371 -1 5 -1L 5 1Z"/>
  <path transform="translate(31 1)" d="M 1 5C 1 2.79086 2.79086 1 5 1L 5 -1C 1.68629 -1 -1 1.68629 -1 5L 1 5ZM 5 1C 7.20914 1 9 2.79086 9 5L 11 5C 11 1.68629 8.31371 -1 5 -1L 5 1Z"/>
  <path transform="translate(6 19)" d="M -0.645941 0.763387C 2.86584 3.73489 9.14748 5.24896 15.177 5.31243C 18.2207 5.34447 21.2688 5.00889 23.9604 4.2689C 26.64 3.53221 29.0401 2.37416 30.7071 0.707108L 29.2929 -0.707108C 27.9599 0.625836 25.9225 1.65527 23.4302 2.34045C 20.95 3.02234 18.0918 3.343 15.198 3.31254C 9.35252 3.25101 3.63416 1.7651 0.645941 -0.763387L -0.645941 0.763387Z"/>
</g>);
export const NegativeFaceDef = () => (<g id="NegativeFace"><path d="M 0 0L 30 0L 30 -2L 0 -2L 0 0Z" transform="translate(6 23)"/>
  <path d="M 0 4C 0 1.79086 1.79086 0 4 0L 14 0C 16.2091 0 18 1.79086 18 4L 18 4C 18 6.20914 16.2091 8 14 8L 4 8C 1.79086 8 0 6.20914 0 4L 0 4Z" transform="translate(23 1)" fill="#FFFFFF"/>
  <path d="M 4 1L 14 1L 14 -1L 4 -1L 4 1ZM 14 7L 4 7L 4 9L 14 9L 14 7ZM 4 7C 2.34315 7 1 5.65685 1 4L -1 4C -1 6.76142 1.23858 9 4 9L 4 7ZM 17 4C 17 5.65685 15.6569 7 14 7L 14 9C 16.7614 9 19 6.76142 19 4L 17 4ZM 14 1C 15.6569 1 17 2.34315 17 4L 19 4C 19 1.23858 16.7614 -1 14 -1L 14 1ZM 4 -1C 1.23858 -1 -1 1.23858 -1 4L 1 4C 1 2.34315 2.34315 1 4 1L 4 -1Z" transform="translate(23 1)"/>
  <path d="M 4 2C 4 3.10457 3.10457 4 2 4C 0.895431 4 0 3.10457 0 2C 0 0.895431 0.895431 0 2 0C 3.10457 0 4 0.895431 4 2Z" transform="translate(33 3)" fill="#000"/>
  <path d="M 0 4C 0 1.79086 1.79086 0 4 0L 14 0C 16.2091 0 18 1.79086 18 4L 18 4C 18 6.20914 16.2091 8 14 8L 4 8C 1.79086 8 0 6.20914 0 4L 0 4Z" transform="translate(1 1)" fill="#FFFFFF"/>
  <path d="M 4 1L 14 1L 14 -1L 4 -1L 4 1ZM 14 7L 4 7L 4 9L 14 9L 14 7ZM 4 7C 2.34315 7 1 5.65685 1 4L -1 4C -1 6.76142 1.23858 9 4 9L 4 7ZM 17 4C 17 5.65685 15.6569 7 14 7L 14 9C 16.7614 9 19 6.76142 19 4L 17 4ZM 14 1C 15.6569 1 17 2.34315 17 4L 19 4C 19 1.23858 16.7614 -1 14 -1L 14 1ZM 4 -1C 1.23858 -1 -1 1.23858 -1 4L 1 4C 1 2.34315 2.34315 1 4 1L 4 -1Z" transform="translate(1 1)"/>
  <path d="M 4 2C 4 3.10457 3.10457 4 2 4C 0.895431 4 0 3.10457 0 2C 0 0.895431 0.895431 0 2 0C 3.10457 0 4 0.895431 4 2Z" transform="translate(11 3)" fill="#000"/>
</g>)

  export const NeutralFace = (props) => {
    const faceWidth = 42;
    const faceHeight = 23;
    let scale=1;
    if(props.width < squareWidth) {
      scale = props.width / squareWidth;
    }

    return <use xlinkHref="#NeutralFace" transform={`translate(${-faceWidth*scale/2},${-faceHeight*scale/2}) scale(${scale})`}/>

  };

  export const PositiveFace = (props) => {
    const faceWidth = 42;
    const faceHeight = 26;
    let scale=1;
    if(props.width < squareWidth) {
      scale = props.width / squareWidth;
    }

    return <use xlinkHref="#PositiveFace" transform={`translate(${-faceWidth*scale/2},${-faceHeight*scale/2}) scale(${scale})`}/>

};

export const NegativeFace = (props) => {
  const faceWidth = 42;
  const faceHeight = 23;
  let scale=1;
  if(props.width < squareWidth) {
    scale = props.width / squareWidth;
  }
  if(props.width < 40) {
    scale *= 1.3;
  }
  return <use xlinkHref="#NegativeFace" transform={`translate(${-faceWidth*scale/2},${-faceHeight*scale/2}) scale(${scale})`}/>

};



// WEBPACK FOOTER //
// ./src/elezioni/components/Bubbles/emoticons.js